export interface Tomo {
  id: number
  emoji: string
  title: string
  desc: string
  resultado: string
  tags: string[]
  badge?: string
}

export const tomos: Tomo[] = [
  {
    id: 1,
    emoji: '🔍',
    title: 'Fundamentos de la Criminalística',
    desc: 'Historia, origen de la disciplina, principio de Locard, principio de intercambio, ciencias auxiliares, Juan Vucetich y el caso Francisca Rojas 1892, marco legal argentino (CPPN, Código Penal), cadena de custodia, ética pericial. Todo el contexto que necesitás para hablar con autoridad desde el primer día.',
    resultado:
      'Tus alumnos entienden por qué Argentina fue el primer país del mundo en resolver un caso judicial con huellas dactilares y por qué eso sigue siendo relevante en 2026.',
    tags: [
      'LOCARD',
      'VUCETICH',
      'CPPN',
      'CADENA DE CUSTODIA',
      'BNDG',
      'CONARC',
      'EAAF',
      'ART. 275 CP',
    ],
  },
  {
    id: 2,
    emoji: '🔍',
    title: 'Inspección Ocular y Escena del Hecho',
    desc: 'Preservación de la escena, actuación del primer respondiente, métodos de búsqueda de indicios, fijación fotográfica y descriptiva, fotografía forense, planimetría y croquis, recolección, embalaje y rotulado, protocolos de actuación argentinos 2026, evidencia digital en la escena, simulaciones para el aula.',
    resultado:
      'Cada clase de escena del hecho tiene el protocolo real argentino, no procedimientos de manuales genéricos o series de televisión.',
    tags: [
      'PRIMER RESPONDIENTE',
      'PAU',
      'FOTOGRAFÍA FORENSE',
      'CROQUIS',
      'EPP',
      'EMBALAJE',
      'PROTOCOLO 485/2024',
      'DRONES',
    ],
  },
  {
    id: 3,
    emoji: '🔍',
    title: 'Evidencias Físicas y Laboratorio Forense',
    desc: 'Clasificación de indicios, evidencias biológicas, análisis de sangre y BPA, huellas y rastros, ADN forense, balística (vainas, proyectiles, GSR), documentología, accidentología vial, microevidencias y el laboratorio criminalístico. Con análisis reales de casos argentinos.',
    resultado:
      'Tus alumnos entienden cómo funciona el laboratorio forense de la PFA por dentro, desde el análisis de ADN del BNDG hasta la microscopía de comparación balística.',
    tags: [
      'ADN',
      'BPA',
      'AFIS',
      'VAINA',
      'GSR',
      'DOCUMENTOLOGÍA',
      'ACCIDENTOLOGÍA',
      'ISO 17025',
      'BNDG',
      'SEM-EDX',
    ],
  },
  {
    id: 4,
    emoji: '🔍',
    title: 'Técnicas Periciales Aplicadas',
    desc: 'Marco general de pericias, balística forense aplicada, dactiloscopía y papiloscopía técnica (Sistema Vucetich), informática forense aplicada, accidentología avanzada, pericias documentales, reconstrucción del hecho, elaboración del informe pericial, el perito en el juicio oral.',
    resultado:
      'Tus alumnos entienden cómo el trabajo pericial se transforma en el informe que llega al tribunal y cómo se defiende ante el abogado defensor más exigente.',
    tags: [
      'VUCETICH',
      'DACTILOSCOPÍA',
      'INFORME PERICIAL',
      'JUICIO ORAL',
      'WRITE BLOCKER',
      'HASH',
      'IMPUGNACIÓN',
      'EDR',
    ],
  },
  {
    id: 5,
    emoji: '🔍',
    title: 'Investigación Criminal Moderna 2026',
    desc: 'Inteligencia criminal, OSINT, ciclo de inteligencia, inteligencia artificial aplicada (reconocimiento facial, análisis predictivo, riesgos y sesgos), drones forenses, escaneo 3D, bases de datos criminales (AFIS, BNDG, INTERPOL), ciberdelitos, deepfakes, IoT como evidencia, tendencias internacionales 2026.',
    resultado:
      'Tus alumnos analizan los dilemas de la IA en la justicia con datos reales, no con especulaciones ni con escenas de CSI.',
    tags: [
      'IA',
      'DRONES',
      'ESCANEO 3D',
      'CIBERDELITOS',
      'DEEPFAKES',
      'OSINT',
      'INTERPOL',
      'LEY 26.388',
      'FARADAY',
      'RANSOMWARE',
    ],
    badge: '⭐ EL MÁS POPULAR',
  },
  {
    id: 6,
    emoji: '🔍',
    title: 'Didáctica de la Criminalística',
    desc: 'Estrategias didácticas específicas para la materia, aprendizaje basado en casos, simulaciones de escena del hecho, secuencias didácticas listas para el aula, herramientas digitales gratuitas, evaluación por competencias, IA para docentes, planificación anual completa. El tomo que te convierte en el docente de Criminalística que todo alumno recuerda.',
    resultado:
      'Tenés el sistema pedagógico completo para enseñar Criminalística con metodologías del siglo XXI, no solo con la pizarra y el libro de texto.',
    tags: [
      'ABP',
      'SIMULACIONES',
      'AULA INVERTIDA',
      'EVALUACIÓN POR COMPETENCIAS',
      'GAMMA',
      'IA DOCENTE',
      'BLOOM',
      'RÚBRICAS',
    ],
  },
]

export interface Bono {
  id: number
  title: string
  shortTitle: string
  valor: string
  desc: string
}

export const bonos: Bono[] = [
  {
    id: 1,
    shortTitle: 'Banco de 300 Evaluaciones de Criminalística',
    title: 'Banco de 300 Evaluaciones de Criminalística',
    valor: '$18.000 ARS',
    desc: '80 preguntas de opción múltiple, 60 verdadero/falso con justificación, 30 casos prácticos para resolver, 50 preguntas de desarrollo, 20 escenas para analizar y 12 rúbricas profesionales completas. Organizadas por tomo, nivel de dificultad y tipo de pensamiento evaluado. Con clave de corrección completa y criterios de evaluación para armar tus propias instancias en minutos.',
  },
  {
    id: 2,
    shortTitle: '100 Casos Criminalísticos para Trabajar en Clase',
    title: '100 Casos Criminalísticos para Trabajar en Clase',
    valor: '$15.000 ARS',
    desc: 'Cien casos pedagógicos completamente desarrollados: desde casos básicos de fundamentos hasta casos integradores complejos de alta dificultad. Todos ambientados en Argentina, con contexto real, preguntas guía por nivel Bloom, resolución para el docente y notas pedagógicas. Organizados por bloque temático (fundamentos, escena, laboratorio, pericias, ciberdelitos, ética). El material que ningún manual tiene.',
  },
  {
    id: 3,
    shortTitle: 'Kit Profesional del Docente Criminalista',
    title: 'Kit Profesional del Docente Criminalista',
    valor: '$15.000 ARS',
    desc: '15 plantillas de planificación, 12 formularios periciales adaptados para el aula (acta de inspección ocular, cadena de custodia, informe pericial, registro fotográfico), 18 checklists operativos listos para imprimir, 10 modelos de comunicación institucional, 20 actividades de inicio de clase, 8 protocolos de evaluación rápida y 150 términos del glosario criminalístico argentino. Todo listo para usar desde mañana.',
  },
  {
    id: 4,
    shortTitle: 'Banco de Recursos Visuales 2026',
    title: 'Banco de Recursos Visuales 2026',
    valor: '$20.000 ARS',
    desc: '15 infografías de principios y conceptos, 12 diagramas de flujo y protocolos, 10 pósters para el aula listos para imprimir en A3, 15 esquemas comparativos, 8 líneas de tiempo visuales, 10 mapas conceptuales, 20 tablas de referencia rápida, 30 fichas coleccionables de tipos de indicios y 12 plantillas de presentación para Gamma y Google Slides. Todo el aula visual de Criminalística que nunca tuviste.',
  },
]
